var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPackageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5 3.5V8.5H14.5V3.5H9.5ZM8.5 0.5C7.39543 0.5 6.5 1.39543 6.5 2.5V9.5C6.5 10.6046 7.39543 11.5 8.5 11.5H15.5C16.6046 11.5 17.5 10.6046 17.5 9.5V2.5C17.5 1.39543 16.6046 0.5 15.5 0.5H8.5ZM3 16.5V21.5H8V16.5H3ZM2 13.5C0.895431 13.5 0 14.3954 0 15.5V22.5C0 23.6046 0.895431 24.5 2 24.5H9C10.1046 24.5 11 23.6046 11 22.5V15.5C11 14.3954 10.1046 13.5 9 13.5H2ZM16 21.5V16.5H21V21.5H16ZM13 15.5C13 14.3954 13.8954 13.5 15 13.5H22C23.1046 13.5 24 14.3954 24 15.5V22.5C24 23.6046 23.1046 24.5 22 24.5H15C13.8954 24.5 13 23.6046 13 22.5V15.5Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackageIcon);
export default __webpack_public_path__ + "static/media/package-icon.f6538da253ceb7882a6cf198e1a6b660.svg";
export { ForwardRef as ReactComponent };